/**
 * 格式化开放接口示例的展示内容，不改变实际保存值。
 */
export function formatExampleContent(content, contentType) {
  const source = content == null ? '' : String(content);
  const trimmed = source.trim();
  const mediaType = String(contentType || '').toLowerCase();
  const looksLikeJson = trimmed.startsWith('{') || trimmed.startsWith('[');
  if (!trimmed || (mediaType.indexOf('json') === -1 && !looksLikeJson)) {
    return source;
  }
  try {
    return JSON.stringify(JSON.parse(trimmed), null, 2);
  } catch (error) {
    return source;
  }
}
